import React, { useEffect, useState } from "react";
import { Formik, useFormik } from "formik";
import * as Yup from "yup";
import { Modal } from "@mui/material";
import Button from "../../../components/common/button/Button";
import TextInput from "../../../components/common/input/TextInput";
import InputSelect from "../../../components/common/input/InputSelect";
import styled from "./CustomerCreate.module.css";
import callApi from "../../../services/api/apiClient";
import { useToast } from "../../../components/toast/Toast";

const customerCreateValidationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  code: Yup.string(),
  phone: Yup.string(),
  address: Yup.string(),
});

const CustomerCreate = ({ isOpen, onClose, getCustomerList, data }) => {
  const [selectedState, setSelectedState] = useState(null);
  const [selectedTownship, setSelectedTownship] = useState(null);
  const [states, setStates] = useState([]);
  const [townships, setTownships] = useState([]);
  const { showToast } = useToast();

  useEffect(() => {
    getAllLocations();
    // if(data){
    //         const defaultValues = {
    //             name:data?.name || "",
    //             code:data?.code || "",
    //             phone:data?.mobile || "",
    //             address:data?.address || ""
    //         };
    //         formik.setValues(defaultValues);
    //         // setSelectedState(data?.state)
    //         // setSelectedTownship(data?.township)
    // }else{
    //     const defaultValues = {
    //         name: "",
    //         code: "",
    //         phone: "",
    //         address: ""
    //     };
    //     formik.setValues(defaultValues);
    // }
  }, [data]);

  // console.log("LLLLL",data , selectedState , selectedTownship)

  const getAllLocations = () => {
    callApi("others/getAllLocations")
      .loadingGroup("createCustomer")
      .execute()
      .then((res) => {
        setStates(res[0]?.state_ids);
      });
  };
  const formik = useFormik({
    initialValues: {
      name: "",
      code: "",
      phone: "",
      address: "",
    },
    validationSchema: customerCreateValidationSchema,
    onSubmit: (values, actions) => {
      const data = {
        name: values?.name,
        code: values?.code,
        mobile: values?.phone,
        street: values?.address,
        township_id: selectedTownship?.value,
        state_id: selectedState?.value,
      };
      callApi("customer/createCustomer")
        .withBody(data)
        .loadingGroup("createCustomer")
        .execute()
        .then((res) => {
          if (res?.status === "success") {
            onClose();
            getCustomerList();
            showToast("Customer is created successfully!", "success");
          } else {
            showToast(res?.message ? res?.message : res?.error, "error");
          }
        })
        .catch((error) => {
          console.log("Error....", error);
          showToast(error, "error");
        });
    },
  });
  console.log(townships, "townships in customer create");
  console.log(states, "states in customer create");
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      className="flex items-center justify-center"
    >
      <div className={styled.detail_container}>
        <p className={styled.title}>Create Customer</p>
        <form action="" onSubmit={formik.handleSubmit}>
          <div className={"mt-[12px]"}>
            <TextInput
              name={"name"}
              type="text"
              label={"Name"}
              placeholder={"Enter name"}
              className={"w-full"}
              onChange={formik.handleChange}
              value={formik.values.name}
              required
            />
            {/* {formik.errors.name && formik.touched.name ? (
                            <p className="text-base text-red-0 mt-[8px]">{formik.errors.name}</p>
                        ) : null} */}
          </div>
          <div className={"mt-[12px]"}>
            <TextInput
              name={"code"}
              type="text"
              label={"Code"}
              placeholder={"Enter code"}
              className={"w-full"}
              onChange={formik.handleChange}
              value={formik.values.code}
              required
            />
          </div>
          <div className={"mt-[12px]"}>
            <TextInput
              name={"phone"}
              type="phone"
              label={"Phone"}
              placeholder={"Enter phone number"}
              className={"w-full"}
              onChange={formik.handleChange}
              value={formik.values.phone}
              required
            />
          </div>
          <div className={"mt-[12px]"}>
            <TextInput
              name={"address"}
              type="text"
              label={"Address"}
              placeholder={"Enter address"}
              className={"w-full"}
              onChange={formik.handleChange}
              value={formik.values.address}
              required
            />
          </div>
          <div className={"mt-[12px]"}>
            <InputSelect
              name={"state"}
              data={states}
              label={"State"}
              className={"w-full"}
              value={selectedState?.id || ""}
              onChange={(e) => {
                const selected = states.find((s) => s.id === e.target.value);
                setSelectedState(selected);
                setTownships(selected?.township_ids || []);
                setSelectedTownship(null);
              }}
              placeholder="Select"
              required
            />
          </div>
          <div className={"mt-[12px]"}>
            <InputSelect
              name={"township"}
              data={townships}
              label={"Township"}
              className={"w-full"}
              value={selectedTownship?.id || ""}
              disabled={selectedState ? false : true}
              onChange={(e) => {
                const selected = townships.find((t) => t.id === e.target.value);
                setSelectedTownship(selected);
              }}
              placeholder="Select"
              required
            />
          </div>
          <Button className={styled.button} type="submit">
            Save
          </Button>
        </form>
      </div>
    </Modal>
  );
};
export default CustomerCreate;
